import ChevronRight from '@mui/icons-material/ChevronRight';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ChevronRightIcon(props: FixMe) {
  return <ChevronRight {...props} />;
}

export default ChevronRightIcon;
